import {customElement, queryAll, state} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {keyed} from "lit/directives/keyed.js";
import {SearchFacade} from "../searchFacade";
import {resolve} from "../../../../container";
import type {FeedEntry} from "../../feedEntry";
import type {SearchTileData} from "../searchGroup";
import type {Maybe} from "../../../../bootstrap/common/types";
import type {EopNewsSearchResultsTile} from "./newsSearchResultsTile";
import {UnLitElement} from "../../../../common/elements";
import type {DirectiveResult} from "lit/directive";


@customElement("eop-news-search-results-tiles")
export class EopNewsSearchResultsTiles extends UnLitElement {

    @state()
    private tileDatas: SearchTileData[];

    @queryAll("eop-news-search-results-tile")
    private tiles: NodeListOf<EopNewsSearchResultsTile>;

    public constructor(private searchFacade: SearchFacade = resolve(SearchFacade)) {
        super();
        this.tileDatas = [];
    }

    public connectedCallback(): void {
        super.connectedCallback();

        this.searchFacade.onChangeGroup(group => this.tileDatas = this.mapEntries(group.entries, group.name));
        this.searchFacade.onNewEntries(group => this.tileDatas = this.mapEntries(group.entries, group.name));
    }

    public render(): TemplateResult {
        return html`
            <div class="tiles">${(this.renderTiles())}</div>`;
    }

    private renderTiles(): DirectiveResult[] {
        return this.tileDatas.map(tileData => keyed(tileData.entry.data.url + tileData.groupName, html`
            <eop-news-search-results-tile .entry=${tileData.entry} .groupName=${tileData.groupName} class="tile"></eop-news-search-results-tile>`));
    }

    private mapEntries(entries: FeedEntry[], groupName: string): SearchTileData[] {
        return entries.map(entry => ({entry: entry, groupName: groupName}));
    }

    public lastFocusable(): Maybe<HTMLElement> {
        return Array.from(this.tiles).lastElement()?.lastFocusable();
    }
}